<template>
  <div class="tab-group">
    <slot />
  </div>
</template>

<style scoped>
.tab-group {
  border-bottom: 1px solid var(--border);
}
</style>
